import { Link as RouterLink } from 'react-router-dom';

// material-ui
import Link from '@mui/material/Link';

// project imports
import { DASHBOARD_PATH } from 'config';
import Logo from '/PIFS logo Red.png';

// ==============================|| MAIN LOGO ||============================== //

export default function LogoSection() {
  return (
    <Link component={RouterLink} to={DASHBOARD_PATH} aria-label="theme-logo">
      <img
        src={Logo}
        alt="Phoenix Insurance"
        style={{
          height: 60,
          width: 'auto',
          maxWidth: 90,
          objectFit: 'contain'
        }}
      />
    </Link>
  );
}
